import { Link } from 'react-router-dom'
import { Alert, Anchor, Paper, Stack, Text, Title } from '@mantine/core'
import { useEvents } from '../data/catalog'
import EventTable from '../components/EventTable'

/**
 * The coalesced calendar — every event regardless of which vendor times it.
 *
 * Vendors differ in how events get *discovered*, which is why management splits
 * by vendor. But once catalogued they are the same kind of thing, and a
 * weekend's racing does not sort itself by timing supplier, so viewing is
 * unified.
 */
export default function Calendar() {
  const { events, error } = useEvents()

  return (
    <Stack gap="lg">
      <div>
        <Title order={1} size="h2">
          Calendar
        </Title>
        <Text c="dimmed" size="sm">
          Every catalogued event. Manage them under the vendor that times them.
        </Text>
      </div>

      {error && <Alert color="red">{error}</Alert>}
      {!events && !error && <Text c="dimmed">Loading…</Text>}

      {events?.length === 0 && (
        <Paper withBorder p="xl">
          <Text c="dimmed" ta="center">
            No events yet. Add one under{' '}
            <Anchor component={Link} to="/vendors/ris">
              RIS
            </Anchor>
            , or scrape the{' '}
            <Anchor component={Link} to="/vendors/tsl">
              TSL
            </Anchor>{' '}
            diary.
          </Text>
        </Paper>
      )}

      {events && events.length > 0 && (
        <Paper withBorder>
          <EventTable events={events} />
        </Paper>
      )}
    </Stack>
  )
}
